import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";



class OzelDurumListeAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "OzelDurumListe";
    super(baseUrl);
  }


  getOzelDurumListe( ozelDurumKodu?: number){
    return this.get("", { params: { ozelDurumKodu: ozelDurumKodu } })

  }

}


export default new OzelDurumListeAPI();
class OzelDurumListeRequest {
  public ozelDurumKodu?: number;

 
  constructor(ozelDurumKodu?: number) {
   
      this.ozelDurumKodu = ozelDurumKodu;

      
  }
}
export { OzelDurumListeRequest };